import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Image,
  Input,
  Text,
  useToast,
  VStack,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../Contexts/AuthContext";
import GoogleAuthButton from "./GoogleAuthButton";

const SignIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const {
    handleLoginWithEmailAndPassword,
    handleLoginWithGoogle,
    handleLogin, 
    isAuthenticated,
  } = useAuth();
  const showToast = useToast();
  const navigate = useNavigate();
  const location = useLocation();
  const [isEmailSubmitting, setIsEmailSubmitting] = useState(false);
  const [isGoogleSubmitting, setIsGoogleSubmitting] = useState(false);

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/");
    }
  }, [isAuthenticated, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsEmailSubmitting(true);
    try {
      await handleLoginWithEmailAndPassword(email, password);
    } catch (error) {
      showToast({
        title: "Error signing in",
        description: error.message,
        status: "error",
      });
    } finally {
      setIsEmailSubmitting(false);
    }
  };

  const handleGoogleSignIn = async () => {
    setIsGoogleSubmitting(true);
    try {
      await handleLoginWithGoogle();
    } catch (error) {
      showToast({
        title: "Error signing in with Google",
        description: error.message,
        status: "error",
      });
    } finally {
      setIsGoogleSubmitting(false);
    }
  };

  const handleMicrosoftSignIn = async () => {
    try {
      await handleLogin();
    } catch (error) {
      showToast({
        title: "Error signing in with Microsoft",
        description: error.message,
        status: "error",
      });
    }
  };

  return (
    <Flex
      minH="80vh"
      align="center"
      justify="center"
      bg="gray.50" // optional background color
      px={4}
    >
      <Box
        maxW="md"
        w="full"
        bg="white"
        p={5}
        borderWidth={1}
        borderRadius="2xl"
        textAlign="center"
        boxShadow="md"
      >
        {/* Logo */}
        <Flex
          mb={6}
          justify="center"
          align="center"
          direction="column" // Centers children vertically
        >
          <Image
            width={"200px"}
            src={"/images/inovora-logo.png"}
            alt="Logo"
            fit={"contain"}
          />
        </Flex>
        <Text fontSize="lg" mb={6} className="coolFont">
          Client Portal
        </Text>
        <VStack spacing={4}>
          <form onSubmit={handleSubmit} style={{ width: "100%" }}>
            <FormControl id="email" mb={4} isRequired>
              <FormLabel>Email</FormLabel>
              <Input
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                bg="white"
                color="black"
              />
            </FormControl>
            <FormControl id="password" mb={6} isRequired>
              <FormLabel>Password</FormLabel>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                bg="white"
                color="black"
              />
            </FormControl>
            <Button
              type="submit"
              colorScheme="blue"
              color={"white"}
              width="full"
              fontWeight={"normal"}
              isLoading={isEmailSubmitting}
            >
              Sign In
            </Button>
          </form>
          <Text fontSize="sm" color="gray.500" pt={2}>
            - or -
          </Text>

          <GoogleAuthButton
            onClick={handleGoogleSignIn}
            isLoading={isGoogleSubmitting}
          />

          {/* <MicrosoftLoginButton
          onClick={handleMicrosoftSignIn}
          style={{ fontSize: "14px" }}
        >
          <span>Sign in with Microsoft</span>
        </MicrosoftLoginButton> */}
        </VStack>
      </Box>
    </Flex>
  );
};

export default SignIn;
